import { eachDayOfInterval } from 'date-fns';
import moment from 'moment';
export const dateToFormat = data => data && !!(data !== null && data !== void 0 && data.length) && moment(data).format('MM/DD/YYYY') || 'N/A';
export const fullMonthName = {
  Jan: 'January',
  Feb: 'February',
  Mar: 'March',
  Apr: 'April',
  May: 'May',
  Jun: 'June',
  Jul: 'July',
  Aug: 'August',
  Sep: 'September',
  Oct: 'October',
  Nov: 'November',
  Dec: 'December'
};
export const monthsToNumber = {
  Jan: '01',
  Feb: '02',
  Mar: '03',
  Apr: '04',
  May: '05',
  Jun: '06',
  Jul: '07',
  Aug: '08',
  Sep: '09',
  Oct: '10',
  Nov: '11',
  Dec: '12'
};
export const sortCycles = (a, b) => {
  if (a.ym > b.ym) {
    return -1;
  }
  if (a.ym < b.ym) {
    return 1;
  }
  return 0;
};
export const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const getDateByMonthNameAndDate = date => {
  if (date && date.length > 0) {
    const dateStringComponents = date.split('-');
    const year = dateStringComponents[0];
    const month = +dateStringComponents[1] - 1;
    const day = dateStringComponents[2];
    return "".concat(monthNames[month], " ").concat(day, ", ").concat(year);
  } else {
    return 'N/A';
  }
};
export const getIntervalBetweenDateAndNow = triggerDay => {
  const currentDate = new Date();
  const currentTriggerDay = new Date(triggerDay);
  const currentDateWithoutTime = new Date(currentDate.getFullYear() + '/' + (currentDate.getMonth() + 1) + '/' + currentDate.getDate());
  if (currentTriggerDay.valueOf() > currentDateWithoutTime.valueOf()) {
    const nowAndTriggerDayInterval = eachDayOfInterval({
      start: currentDateWithoutTime,
      end: currentTriggerDay
    });
    return nowAndTriggerDayInterval.length;
  }
  return 0;
};